import { Trans, useTranslation } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";
import React from "react";
import { usePortal } from "../../../../../Providers/PortalProvider";
import {
  ACTION_SET_SESSION_EXPIRED,
  useAuth,
} from "../../../../providers/AuthProvider";

const SessionExpiredDialog = (props) => {
  const { t } = useTranslation();
  const { terms } = usePortal();
  const { logout, acceptTermsOfService, dispatch } = useAuth();

  const onClose = () => {
    dispatch({
      type: ACTION_SET_SESSION_EXPIRED,
      payload: {
        value: false,
      },
    });
  };

  return (
    <Popup onClose={props.onClose}>
      <PopupHeading>{t("Session timed out")}</PopupHeading>
      <PopupContent>
        <p>
          <Trans>
            Due to inactivity, your session has timed out and you have been
            logged out.
          </Trans>
        </p>
      </PopupContent>

      <PopupActions>
        <PopupButton onClick={() => logout()}>{t("Ok")}</PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default SessionExpiredDialog;
